/**
 * Central registry of debug flags.
 * Set a flag to `true` to enable coloured console output for that subsystem.
 * All flags are ignored in production builds.
 */
export const enabledDebuggers = {
  checkout: true,
  'checkout:payment': true,
  'checkout:apple-pay': true,
  'checkout:order-preview': false,
  auth: false,
  analytics: false,
  onboarding: false,
  bio: false,
  studio: false,
  subscribe: false,
  post: false,
  tipping: false,
  navigation: false,
  'ai-echo-bot': true,
  // The SaaS promo-coupon lookup that replaced the free trial. On by default
  // because its every outcome is a "why is no discount showing" answer, and a
  // silent tag would leave that question unanswerable. Dev-only, like the rest.
  'saas:promo-coupon': true,
};

export type DebugTag = keyof typeof enabledDebuggers;

const isDev =
  typeof process !== 'undefined' ? process.env.NODE_ENV !== 'production' : true;

export function isDebugEnabled(name: DebugTag): boolean {
  return isDev && enabledDebuggers[name];
}
